import React from 'react';
import Widget from '../../../widgets/Widget';
import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import { ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE } from '../../../widgets/assetStatusUtils';

const WidgetSettingsPreview = ({
  edit,
  dims,
  deviceDatastream,
  validDatastreams,
  findDatastreamByReference,
  preserveTitleSpaces,
  resizeWidget,
  defaultDivHeight,
  defaultDivWidth,
  handleTerminalCleared,
  updateWidgetLivePropsById,
}) => (
  <div
    style={{
      flex: 1,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--header-background)'
    }}
  >
    {(() => {
      const previewDatastreamsBase = [
        ...((deviceDatastream || []).filter(ds => ds)),
        ...((validDatastreams || []).filter(ds => ds)),
      ];

      const selectedDs = findDatastreamByReference(
        previewDatastreamsBase,
        edit.dataId,
        edit.dataPin,
      );
      const previewDatastreams = previewDatastreamsBase.map((datastream) => {
        if (String(datastream?.id) !== String(selectedDs?.id)) {
          return datastream;
        }

        const nextDatastream = { ...datastream };
        const liveValue = edit.props?.value;
        const shouldUseEditorLiveValue =
          edit.type === 'slider'
          || edit.type === STATUS_ARROW_WIDGET_TYPE
          || !selectedDs;

        if (edit.props?.min !== undefined && edit.props?.min !== null && edit.props?.min !== '') {
          nextDatastream.min = edit.props.min;
        }
        if (edit.props?.max !== undefined && edit.props?.max !== null && edit.props?.max !== '') {
          nextDatastream.max = edit.props.max;
        }
        if (edit.props?.unit !== undefined && edit.props?.unit !== null && String(edit.props.unit).trim() !== '') {
          nextDatastream.unit = edit.props.unit;
        }
        if (shouldUseEditorLiveValue && liveValue !== undefined && liveValue !== null && liveValue !== '') {
          nextDatastream.value = liveValue;
          nextDatastream.defaultValue = liveValue;
        }

        return nextDatastream;
      });
      const previewDims =
        edit.type === ENVIRONMENTAL_STATUS_WIDGET_TYPE
          ? {
            width: Math.max(220, Math.min(360, Math.round((Number(dims?.width) || 1280) * 0.26))),
            height: Math.max(240, Math.min(320, Math.round((Number(dims?.height) || 720) * 0.32))),
          }
          : edit.type === ASSET_STATUS_WIDGET_TYPE
            ? {
              width: Math.max(260, Math.min(520, Number(edit.width) || 420)),
              height: Math.max(170, Math.min(340, Number(edit.height) || 230)),
            }
            : edit.type === STATUS_ARROW_WIDGET_TYPE
              ? {
                width: 360,
                height: 150,
              }
          : {
            width: 268,
            height: 268,
          };

      let pinForWidgetProps = null;
      if ((edit.type === 'chart' || edit.type === 'table') && edit.props?.curves?.length > 0) {
        pinForWidgetProps = edit.props.curves[0].pin;
      } else {
        pinForWidgetProps = selectedDs?.pin;
      }

      return (
        <Widget
          transparentBackground={edit.transparentBackground}
          draggable={false}
          title={preserveTitleSpaces(edit.title.replace(/^\[.*?\]\s*/, ''))}
          dataId={edit.dataId}
          dataPin={pinForWidgetProps || ''}
          decimals={selectedDs?.decimals || ''}
          deviceId={edit.deviceId}
          resizeWidget={resizeWidget}
          resize={false}
          id={edit.type + '-' + edit.id}
          width={previewDims.width}
          height={previewDims.height}
          type={edit.type}
          defaultDivHeight={defaultDivHeight}
          defaultDivWidth={defaultDivWidth}
          extraProps={edit.props}
          onTerminalCleared={handleTerminalCleared}
          datastreams={previewDatastreams}
          preferDatastreamDefaultValue
          onWidgetPropsChange={edit.type === 'slider'
            ? (partialProps) => updateWidgetLivePropsById(edit.id, partialProps, { syncEdit: true })
            : edit.type === STATUS_ARROW_WIDGET_TYPE
              ? (partialProps) => updateWidgetLivePropsById(edit.id, partialProps, { syncEdit: true })
            : undefined}
        />
      );
    })()}
  </div>
);

export default WidgetSettingsPreview;
